import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0adfb5b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    ref: "input",
    type: "text",
    placeholder: _ctx.prompt,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('input', $event.target.value)))
  }, null, 40, _hoisted_1)), [
    [_vModelText, _ctx.value]
  ])
}